import { Outlet, useLocation, useParams } from 'react-router-dom'
import ListaConversas from '@/components/atendimento/ListaConversas'

const SEM_LISTA = ['agenda-ia', 'chatbot']

export default function AtendimentoLayout() {
  const location = useLocation()
  const params = useParams()
  const segmento = params.id ?? location.pathname.split('/').pop() ?? null

  if (segmento && SEM_LISTA.includes(segmento)) {
    return <div style={{ padding: '24px 20px', maxWidth: 900, margin: '0 auto' }}><Outlet /></div>
  }

  return (
    <div className="atend" data-aberta={params.id ? 'true' : 'false'}>
      <ListaConversas />
      <section className="atend-conversa"><Outlet /></section>
    </div>
  )
}
